import tzlookup from '@photostructure/tz-lookup';
import type { MyChronMapPoint, TrackContributionGpsCoord } from '@kangaroo/shared';

type GpsCoord = { lat: number; lon: number };

export function gpsCoordsCenter(points: GpsCoord[]): GpsCoord | null {
  if (points.length === 0) {
    return null;
  }

  const lat = points.reduce((sum, point) => sum + point.lat, 0) / points.length;
  const lon = points.reduce((sum, point) => sum + point.lon, 0) / points.length;
  return { lat, lon };
}

export function resolveTimezoneFromCoordinates(lat: number, lon: number): string | undefined {
  try {
    const timeZone = tzlookup(lat, lon);
    return timeZone || undefined;
  } catch {
    return undefined;
  }
}

export function resolveTimezoneFromMapPreview(mapPreview: MyChronMapPoint[]): string | undefined {
  const center = gpsCoordsCenter(mapPreview);
  if (!center) {
    return undefined;
  }

  return resolveTimezoneFromCoordinates(center.lat, center.lon);
}

export function resolveTimezoneFromCircuitPolyline(polyline: TrackContributionGpsCoord[]): string | undefined {
  const center = gpsCoordsCenter(polyline);
  if (!center) {
    return undefined;
  }

  return resolveTimezoneFromCoordinates(center.lat, center.lon);
}
